"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTIONS_CATEGORY_KEY = 'base';
exports.ACTIONS_COMPONENT_KEY = 'actions';